import React from 'react';

import styles from './InputLoader.module.scss';

const InputLoader = () => <div className={styles.loader} />;

export default InputLoader;
